import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MobilesettingsComponent } from './mobilesettings.component';
import { MaterialModuleMobi } from '../material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { VlHttpService,SharedModule, AppPermissionsPipe } from 'shared-library';
import { MediaModule } from '../media/media.module';




@NgModule({
  declarations: [
    MobilesettingsComponent
  ],
  imports: [
    CommonModule,
    FormsModule,ReactiveFormsModule,
    MaterialModuleMobi,
    SharedModule,
    MediaModule,
    AppPermissionsPipe
  ],
  exports:[
    MobilesettingsComponent
  ],
  providers:[
    VlHttpService
  ]
})
export class MobilesettingsModule { }
